import { createTheme, Theme } from '@mui/material/styles';

// A custom theme for this app
const theme: Theme = createTheme({
  palette: {
    mode: 'dark',
  },
});

export default theme;